// Layout.js
import React,{useState} from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import SubHeader from './SubHeader';
import Footer from './Footer';

const Layout = ({ children, title, subtitle }) => {
  const location = useLocation();
  const [dateRange, setDateRange] = useState(null);

  const isLoginPage = location.pathname === '/login';
  const isHomePage = location.pathname === '/';
  const isDetailHistory = location.pathname.startsWith('/detailhistory/');
  const isDetailProses = location.pathname.startsWith('/detailproses/');
  const isScheduleDetail = location.pathname.startsWith('/schedule-detail/');

  return (
    <div>
      {!isLoginPage && !isHomePage && <Header title={title} />}
      {!isLoginPage && !isHomePage && !isDetailHistory && !isDetailProses && !isScheduleDetail && (
        <SubHeader title={subtitle} setDateRange={setDateRange} />
      )}
      <main className="main_wrap">
        {React.cloneElement(children, { dateRange }) /* Pass range to children */}
      </main>
      {!isLoginPage && <Footer />}
    </div>
  );
};


export default Layout;
